import { RadParticipantLight } from '../../lib/types/models/rad/rad-participant'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getAffectedStaffRadParticipant(id: number) {
  return restApiClient
    .url(constructApiUrl(API.affectedStaffs.getRadParticipant.url, { id }))
    .get<RadParticipantLight>()
}
